import React from 'react'
import classes from './Loader.module.sass'

type Props ={
  large?: boolean
}

export const Loader = ({large}: Props) => {
  return (
    <div className={large ? classes.containerLarge : classes.container}>
      <div className={large ? classes.inContainerLarge : classes.inContainer}>
    
      </div>
    </div>
  )
}
